import { defineStore } from 'pinia'
import { type TBreakpoint } from '~/types/components/breakpoint-types'
import { breakpoints } from '~/constants/breakpoints'

type TStoreState = {
  currentBreakpoint: TBreakpoint | undefined;
  index: number | undefined
};

export const useBreakpointsStore = defineStore('breakpoints', {
  state: (): TStoreState => {
    return {
      currentBreakpoint: breakpoints[0],
      index: 0
    }
  },
  actions: {
    setCurrentBreakpoint (breakpoint: TBreakpoint) {
      this.$state = {
        currentBreakpoint: breakpoint,
        index: breakpoints.indexOf(breakpoint)
      }
      console.info(
        `✔ Breakpoint changed to ${this.$state.currentBreakpoint.name}`
      )
    }
  },
  getters: {
    getCurrentBreakpoint: state => state.currentBreakpoint,
    getCurrentBreakpointIndex: state => state.index
  }
})
